
(function() {
'use strict';

function createTab(init) {
	const tab = this;
	init.setDataTableArgs( {

		tableId: 		'#data-table-project-projects',

		readTableName: 	'tblJobs',
		editTableName: 	'tblJobs',
		primaryKey: 	'JobID',

		hasColumnFilters: 	false,
		canSearch: 			false,
		canSort:			false,
		paging:             false,
		pagelength:         -1,

		actionData:			'datatable_get_project_projects',

		fields: [
			{
				label:      'Project #',
				columnName: 'JobNumber',
				type:       'project-link',
		 	},
			{
				label:      'Description',
				columnName: 'JobDescription',
		 	},
			{
				label:      'Client',
				columnName: 'ClientName',
		 	},
			{
				label:      '# Samples',
				columnName: 'SampleCount',
			},
			{
				label:      'Status',
				columnName: 'JobStatus',
			},
		],

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			data.ProjectID = tab.controller.ProjectID || -1;
			return data;
		},

	} );

	var vmProject = null,
		projectTab = null;

	init.setController( new TabControllerVue({
        el: '#v-project-name',
        store, // vuex store
		lockUpdates: true,
        created: function() {
			this.clearProject();
        },
        methods: {
			resetData() {
				this.ProjectID          = null,
				this.ProjectName        = null,
				this.ProjectDescription = null,
				this.ClientID           = null,
				this.PO                 = null,
				this.LabComment         = null,
				this.ReportComment      = null,
				this.ProjectComplete    = false,
				this.ProjectCount       =  0,
				this.client             = null,
				this.clientData         = {
					Projects: [],
				};
			},
			onReset(){
				tab.clearTable();
			},
			clearProject: function() {
				this.reset();
				return true;
			},

			// Create a new project
            // Event safe
			newProject: function(onSuccessOrEvent = null, onError = null, name = null, clientId = null) {
                // Ignore Event
				if ( onSuccessOrEvent instanceof Event ) { onSuccessOrEvent = null }
				const onSuccess = onSuccessOrEvent
					? () => onSuccessOrEvent( this.ProjectID )
					: null;

				this.ProjectID = null;
				const data = {
					ProjectName        : name ? name : this.ProjectName,
					ProjectDescription : this.ProjectDescription,
					ClientID           : clientId ? clientId : this.client ? this.client.id : null,
					PO                 : this.PO,
					LabComment         : this.LabComment,
					ReportComment      : this.ReportComment,
					ProjectComplete    : this.ProjectComplete ? 1 : 0,
				};
				const insert = () => this.updateProject(data, true, onSuccess, onError);
				if ( name || clientId ) {
					this.lockUpdates();
					if ( name != null ) {
						this.ProjectName = name;
					}
					if ( clientId ) {
						this.ClientID = clientId;
						this.client = this.clientList.find( client => client.id == clientId ) || null;;
						this.ajaxLoadClientData(
							() => this.unlockUpdatesLater('newProject ajaxLoadClientData onSuccess', insert),
							() => this.unlockUpdatesLater('newProject ajaxLoadClientData onError', onError)
						);
					} else {
						this.unlockUpdatesLater('newProject', insert);
					}
				} else {
					insert();
				}
				tab.autofocus();
			},

			doCreateNew() { this.clearProject(); tab.autofocus(); },

			// Open the samples tab and set this project as the current one
			loginProject: function(){
				if ( !this.ProjectID ) {
					this.newProject( this.loginProject );
					return;
				}
				vmProject.setProjectFromProjectId( this.ProjectID, () => {
					if ( projectTab )
						projectTab.show();
					tab.close();
				});
			},

			doLogin() { return this.loginProject(); },

			updateProject: function(data, insert = false, onSuccess = null, onError = null) {
				if ( this.getUpdateLockLevel() ) { return; }
				if ( ! insert && ! this.ProjectID ) { return; }
				if ( ! this.client || ! this.client.id || this.client.id <= 0 ) {
					return WarningModalManager.show({
						title   : "Missing client",
						message : "Please select a client before adding.",
					});
				}
				const _this = this;

				window.ajaxCall({
					data : {
						action: 'update_long_project',
						id: this.ProjectID,
						data: data,
					},
					onSuccess : function( response ) {
						if ( ! response.success || ! response.data ) {
							console.log( response.message ? response.message : response );
							return;
						}
						const data = response.data;
						if ( data && _this.ProjectID != data.ProjectID ) {
							_this.loadProjectData( data, onSuccess );
						} else {
							typeof onSuccess == 'function' && onSuccess();
						}
					},
					onError: onError,
				});
			},

			loadProjectData: function ( data, onLoaded = null ) {
				if ( !data ) { return this.clearProject(); }

				this.lockUpdates( 'loadProjectData' );
				this.client = this.clientList.find( client => client.id == data.ClientID ) || null;
				this.ProjectID          = data.ProjectID;
				this.ProjectName        = data.ProjectName;
				this.ProjectDescription = data.ProjectDescription;
				this.ClientID           = data.ClientID;
				this.PO                 = data.PO;
				this.LabComment         = data.LabComment;
				this.ReportComment      = data.ReportComment;
				this.ProjectComplete    = data.ProjectComplete == '1';
				this.ProjectCount       = data.ProjectCount,
				this.unlockUpdatesLater( 'loadProjectData' );
				tab.drawTable();
				if ( typeof onLoaded == 'function' ) { return onLoaded(); }
			},

			loadProject: function( projectId, onSuccess = null, onError = null ) {
				const vm = this;
				projectId = parseInt( projectId );
				if ( ! projectId ) {
					alert( 'Invalid Project' );
					typeof onError == 'function' && onError();
				}
				this.clearProject();
				this.lockUpdates( 'loadProject' );
				this.ProjectID = projectId;

				window.ajaxCall({
					data : {
						action: 'get_long_project',
						id: projectId,
					},
					onSuccess : function( response ) {
						vm.loadProjectData( response.data, onSuccess );
						vm.unlockUpdates( 'loadProject' ); // loadProjectData still has a waiting lock
						tab.drawTable();
					},
					onError : function( response ) {
						alert( 'Could Not Load Project' );
						vm.unlockUpdatesLater( 'loadProject', onError );
					},
				});
			},

			ajaxLoadClientData: function(onSuccess = null, onError = null) {
				if ( ! this.client ) {
					return;
				}
				const vm = this;
	            window.ajaxCall({
	                data : {
	                    action: 'get_client_data',
	                    client_id: vm.client.id
	                },
	                onSuccess : function( response ) {
						vm.clientData = response.data;
						typeof onSuccess == 'function' && onSuccess();
	                },
					onError: function() { typeof onError == 'function' && onError() },
	            });
			},

			// Add elsewhere

			addClient: function() {
				const clientManagementTab = AppTabs.getTab( 'client-management' );
				clientManagementTab.show();
				clientManagementTab.controller.addClient();
			},

			// Delete a project
			deleteProject: function() {
				if ( this.getUpdateLockLevel() ) { return; }
				if ( ! this.ProjectID ) { return; }
				const projectID = this.ProjectID;
				if ( projectID == vmProject.ProjectID ) {
					vmProject.ProjectID = null;
					vmProject.projectProject = null;
					vmProject.projectGoBetween = null;
					vmProject.clientData.Projects = vmProject.clientData.Projects.filter( project => project.ProjectID != projectID );
				}
				this.clearProject();
				window.ajaxCall({
					data : {
						action: 'delete_long_project',
						id: projectID,
					},
				});
			},

			doElementAction: function(target, elClass, event) {
				this.loadProject( target.dataset.projectId, tab.show );
			},
		},
		computed: {
			// data from local storage
			clientList: 			x => store.state.clientList,
		},
		watch: {
			ProjectName        : function( value ) {
				this.updateProject({ ProjectName : value });
				// Force update this project's name in Project tab
				if ( this.client && vmProject.client && this.client.id == vmProject.client.id ) {
					const entry = vmProject.clientData.Projects.find( project => project.ProjectID == this.ProjectID ) || null;
					if ( entry ) 
						entry.ProjectName = value;
					vmProject.projectGoBetween = value;
				}
			},
			ProjectDescription : function( value ) { return this.updateProject({ ProjectDescription : value }) },
			ClientID           : function( value ) { return this.updateProject({ ClientID : value }) },
			PO                 : function( value ) {
				let returnVal = this.updateProject({ PO : value });
				if ( this.client && vmProject.client && this.client.id == vmProject.client.id ) {
					const entry = vmProject.clientData.Projects.find( project => project.ProjectID == this.ProjectID ) || null;
					if ( entry ) 
						entry.PO = value;
					if(vmProject.projectProject && vmProject.projectProject.ProjectID == this.ProjectID)
						vmProject.JobPO = value;					
				}
				return returnVal;
			},
			LabComment         : function( value ) { return this.updateProject({ LabComment : value }) },
			ReportComment      : function( value ) { return this.updateProject({ ReportComment : value }) },
			ProjectComplete    : function( value ) { return this.updateProject({ ProjectComplete : value ? 1 : 0 }) },
			client: function( newValue, oldValue ) {
				if ( ! this.client ) { return }
				this.ajaxLoadClientData();
				if ( ! this.ProjectID ) {
					this.newProject( tab.drawTable );
				} else {
					this.updateProject({ clientID : this.client.ClientID });
				}
			},
		},
	}) );

	projectTab = AppTabs.getTab( 'project' );
	vmProject = projectTab.controller;
}

AppTabs.createTab( {
	name: 'project-name',
	icon: 'flask',
	text: 'Project Name',
	actionElementClasses: [ 'project-name-link' ],
	//preload: 'vmProjectName',
	create: createTab,
} );

})();
